import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'cbr_accounts',
    name: ROUTE_NAMES.CBR_ACC,
    component: () => import('../CbrAccPage.vue'),
  },
  {
    path: 'cbr_accounts_avaliables',
    name: ROUTE_NAMES.CBR_ACC_AVALIABLE,
    component: () => import('../CbrAvaliabilityPage.vue'),
    meta: {
      perms: ROUTE_NAMES.CBR_ACC
    }
  },
]